<template>
    <div class="w-full space-y-8" v-if="ppeRegister">
        <ui-header :title="`PPE Register ${ppeRegister.date}`">
        </ui-header>
        <ui-data-grid>
            <ui-data-grid-item label="Package" wide :value="ppeRegister.packageName"></ui-data-grid-item>
            <ui-data-grid-item label="Date" :value="ppeRegister.date"></ui-data-grid-item>
            <ui-data-grid-item label="People" wide>
                <div class="flex mt-8 border-t border-b border-gray-200 bg-gray-50 text-xs text-gray-500 font-semibold">
                    <div class="w-6 flex-shrink-0"></div>
                    <div class="flex-1 border-l border-r border-gray-200 px-2 py-1" style="min-width: 55px;">Name</div>
                    <element-size-sync ref="sizesync" :other-elements="() => getPersonElements('equipment'+equipment.id)"
                                       v-for="(equipment) in ppeRegister.equipment" :key="equipment.id">
                        <div class="border-r border-gray-200 p-0" style="min-width: 32px" ref="equipmentName">
                            <rotate>
                                <autoresizable-input :post-resize="resize"
                                                     measure="p-1 m-0 border-none text-xs font-semibold text-gray-500"
                                                     :min="32">
                                    <page-cell name="name" v-model="equipment.name" disabled
                                               class="border-none shadow-none bg-transparent text-xs overflow-visible text-gray-500 font-semibold p-1 m-0">
                                    </page-cell>
                                </autoresizable-input>
                            </rotate>
                        </div>
                    </element-size-sync>
                    <div class="w-20 border-r border-gray-200 px-2 py-1">Signature</div>
                    <div class="w-6 flex-shrink-0 ml-2"></div>
                </div>
                <div class="flex border-collapse border-b border-gray-200 draggable"
                     v-for="person in ppeRegister.people" ref="people"
                >
                    <div class="w-6 flex-shrink-0">
                    </div>
                    <div class="flex-1 border-l border-r">
                        <div class="flex-1 border-gray-200 px-0 py-0 overflow-x-auto relative">
                            <div class="text-sm px-2 py-1">
                                {{ person.name ? person.name : "&nbsp;" }}
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-0 border-r border-gray-200 justify-center items-center"
                         style="min-width: 32px"
                         v-for="(equipment) in ppeRegister.equipment" :key="equipment.id"
                         :ref="'equipment'+equipment.id">
                        <div class="flex m-0 p-0 justify-center items-center">
                            <input type="checkbox" class="m-0" :name="equipment.name" :disabled=true
                                   :class="'bg-gray-200'"
                                   :checked="person.equipmentIds.some(id => id === equipment.id)">
                        </div>
                    </div>
                    <div class="w-20 flex border-r border-gray-200 px-0 py-0 relative">
                        <img v-if="person.signature" :src="person.signature" height="28px" width="100%"
                             class="m-0 p-0 absolute"
                             style="right:0px; top:0px; height:28px; z-index: 20">
                    </div>
                    <div class="w-6 flex-shrink-0 ml-2 mt-1">
                    </div>
                </div>
            </ui-data-grid-item>
            <ui-data-grid-item label="Given By" :value="ppeRegister.givenByName"></ui-data-grid-item>
            <ui-data-grid-item label="Position" :value="ppeRegister.givenByPosition"></ui-data-grid-item>
            <ui-data-grid-item label="Signed">
                <img v-if="ppeRegister.signature" :src="ppeRegister.signature" height="128px" width="auto"
                     class="m-0 p-0"
                     style="right:0px; top:0px; height:128px; z-index: 20">
                <span v-else>-</span>
            </ui-data-grid-item>
        </ui-data-grid>

    </div>
</template>

<script>

import Rotate from "../../ui/Rotate.vue";
import ElementSizeSync from "../../ui/ElementSizeSync";
import AutoresizableInput from "../../ui/AutoresizableInput";
import PageCell from "../../ui/PageCell.vue";
import PpeRegisterPerson from "../../hsqe/ppe-register/PpeRegisterPerson.vue";

export default {
    components: {PpeRegisterPerson, PageCell, AutoresizableInput, ElementSizeSync, Rotate},
    props: {
        ppeRegister: Object,
    },
    data() {
        return {}
    },
    methods: {
        getPersonElements(name) {
            if (this.$refs[name]) {
                return this.$refs[name];
            }
            return [];
        },
        resize() {
            this.$nextTick(() => {
                this.$refs.sizesync ? this.$refs.sizesync.map((i) => i.resizeElements()) : false
            })
        },
    },
    async mounted() {
    }
}
</script>
